import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import volumeOn from "../assets/volumeon.svg";
import volumeOff from "../assets/volumeoff.svg";
import NavLink from "./navlink";
import "./header.css";

const Header = ({ soundEnabled, onToggleSound }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const createSectionHandler = (sectionId) => (event) => {
    const isHomeRoute = location.pathname === "/";
    const nextHash = sectionId === "home" ? "" : `#${sectionId}`;
    const currentHash = location.hash || "";

    if (!isHomeRoute) {
      return;
    }

    if (sectionId === "home") {
      event.preventDefault();
      window.history.replaceState({}, "", "/");
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (currentHash === nextHash) {
      event.preventDefault();
      const target = document.getElementById(sectionId);

      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  return (
    <header
      className={`site_header${isScrolled ? " is_scrolled" : ""}${
        isExpanded ? "" : " is_compact"
      }`}
    >
      <div className="site_header_shell">
        <NavLink
          className="is_brand"
          linkText="Emily Dickinson"
          onClick={createSectionHandler("home")}
          to="/"
        />

        <nav className="site_header_nav" aria-label="Primary">
          <NavLink
            linkText="Home"
            onClick={createSectionHandler("home")}
            to="/"
          />
          <NavLink
            linkText="Portraits"
            onClick={createSectionHandler("portraits")}
            to="/#portraits"
          />
          <NavLink
            linkText="Collage"
            onClick={createSectionHandler("collage")}
            to="/#collage"
          />
          <NavLink
            linkText="Timeline"
            onClick={createSectionHandler("timeline")}
            to="/#timeline"
          />
        </nav>

        <div className="site_header_actions">
          <button
            aria-label={isExpanded ? "Minimize header" : "Expand header"}
            className="site_header_toggle"
            onClick={() => setIsExpanded((current) => !current)}
            type="button"
          >
            {isExpanded ? "Minimize" : "Expand"}
          </button>

          <button
            aria-label={soundEnabled ? "Mute music" : "Unmute music"}
            className="site_header_volume"
            onClick={onToggleSound}
            type="button"
          >
            <img
              alt=""
              aria-hidden="true"
              src={soundEnabled ? volumeOn : volumeOff}
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
